import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  users: [],
  getUsersStatus: IDLE,

  userRoles: [],
  getUserRolesStatus: IDLE,

  createUserStatus: IDLE,
  updateUserStatus: IDLE,
  deleteUserStatus: IDLE,

  bulkEditUsersStatus: IDLE
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    getUsers(state) {
      state.getUsersStatus = LOADING;
    },
    getUsersSucceeded(state, action) {
      state.users = action.payload;
      state.getUsersStatus = SUCCEEDED;
    },
    getUsersFailed(state) {
      state.getUsersStatus = FAILED;
    },

    getUserRoles(state) {
      state.getUserRolesStatus = LOADING;
    },
    getUserRolesSucceeded(state, action) {
      state.userRoles = action.payload;
      state.getUserRolesStatus = SUCCEEDED;
    },
    getUserRolesFailed(state) {
      state.getUserRolesStatus = FAILED;
    },

    createUser(state) {
      state.createUserStatus = LOADING;
    },
    createUserSucceeded(state) {
      state.createUserStatus = SUCCEEDED;
    },
    createUserFailed(state) {
      state.createUserStatus = FAILED;
    },

    updateUser(state) {
      state.updateUserStatus = LOADING;
    },
    updateUserSucceeded(state) {
      state.updateUserStatus = SUCCEEDED;
    },
    updateUserFailed(state) {
      state.updateUserStatus = FAILED;
    },

    deleteUser(state) {
      state.deleteUserStatus = LOADING;
    },
    deleteUserSucceeded(state) {
      state.deleteUserStatus = SUCCEEDED;
    },
    deleteUserFailed(state) {
      state.deleteUserStatus = FAILED;
    },

    bulkEditUsers(state) {
      state.bulkEditUsersStatus = LOADING;
    },
    bulkEditUsersSucceeded(state) {
      state.bulkEditUsersStatus = SUCCEEDED;
    },
    bulkEditUsersFailed(state) {
      state.bulkEditUsersStatus = FAILED;
    },

    clearUsers(state) {
      state.users = [];
      state.getUsersStatus = IDLE;
    }
  }
});

export const {
  getUsers,
  clearUsers,
  getUsersSucceeded,
  getUsersFailed,

  getUserRoles,
  getUserRolesSucceeded,
  getUserRolesFailed,

  createUser,
  createUserSucceeded,
  createUserFailed,

  updateUser,
  updateUserSucceeded,
  updateUserFailed,

  deleteUser,
  deleteUserSucceeded,
  deleteUserFailed,

  bulkEditUsers,
  bulkEditUsersSucceeded,
  bulkEditUsersFailed
} = usersSlice.actions;

export default usersSlice.reducer;
